import { useState } from "react";
import Button from "./ui/Button.jsx";
import Badge from "./ui/Badge.jsx";

function severityIcon(sev) {
  const s = String(sev || "").toLowerCase();
  if (s === "critical") return "🔴";
  if (s === "warning") return "🟡";
  return "ℹ️";
}

function formatVal(v) {
  if (v == null) return "—";
  if (typeof v === "object") {
    try {
      return JSON.stringify(v);
    } catch {
      return String(v);
    }
  }
  return String(v);
}

export default function DriftReport({ changes = [], onDismiss, onContinue, onFixRegressions }) {
  const [expanded, setExpanded] = useState(true);
  const list = Array.isArray(changes) ? changes : [];
  const count = list.length;
  const hasBad = list.some((c) => {
    const s = String(c?.severity || "").toLowerCase();
    return s === "critical" || s === "warning";
  });

  return (
    <div
      style={{
        border: "1px solid var(--border-bright)",
        borderRadius: "6px",
        background: "var(--bg-surface)",
        marginBottom: "16px",
        overflow: "hidden",
      }}
    >
      <button
        type="button"
        onClick={() => setExpanded((e) => !e)}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
          padding: "14px 16px",
          background: "var(--bg-elevated)",
          border: "none",
          cursor: "pointer",
          color: "var(--text-primary)",
          textAlign: "left",
        }}
      >
        <span style={{ fontWeight: 600, fontSize: "14px" }}>Changes since your last session</span>
        <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Badge variant="warning">{count}</Badge>
          <span className="text-dim" style={{ fontSize: "12px" }}>
            {expanded ? "Hide" : "Show"}
          </span>
        </span>
      </button>

      {expanded ? (
        <>
          <ul style={{ listStyle: "none", padding: "12px 16px", maxHeight: "280px", overflow: "auto" }}>
            {list.map((c) => (
              <li
                key={c.id || c.title}
                style={{
                  padding: "12px 0",
                  borderBottom: "1px solid var(--border)",
                }}
              >
                <div style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
                  <span style={{ fontSize: "14px" }} aria-hidden>
                    {severityIcon(c.severity)}
                  </span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 500, marginBottom: "4px" }}>{c.title}</div>
                    <p className="text-secondary" style={{ fontSize: "13px", lineHeight: 1.45 }}>
                      {c.detail}
                    </p>
                    <p
                      className="font-mono text-dim"
                      style={{ fontSize: "11px", marginTop: "8px", wordBreak: "break-word" }}
                    >
                      Was: {formatVal(c.previousValue)} → Now: {formatVal(c.currentValue)}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              padding: "12px 16px 16px",
              borderTop: "1px solid var(--border)",
            }}
          >
            {hasBad ? (
              <Button variant="danger" size="sm" onClick={() => onFixRegressions?.()}>
                Fix regressions first
              </Button>
            ) : null}
            <Button variant="secondary" size="sm" onClick={() => (onContinue ?? onDismiss)?.()}>
              Continue where I left off
            </Button>
            <Button variant="ghost" size="sm" onClick={() => onDismiss?.()}>
              Dismiss
            </Button>
          </div>
        </>
      ) : null}
    </div>
  );
}
